<template>
  <p class="doc-detail" v-html="detail.content" v-if="detail.content"></p>
</template>

<script>
import api from "@/api/doc"
import { GetQueryString } from '@/utils/tools.js'

export default {
  name: 'docdetail',
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getProtocolDetail(GetQueryString('id'))
  },
  methods: {
    getProtocolDetail(id) {
      api.getProtocolDetail({ id }).then(res => {
        window.document.title = res.data.ruleTitle;
        this.detail = res.data
      })
    }
  }
};
</script>

<style lang="less">
.doc-detail {
  user-select: text;
  background-color: #f8f8f8;
  font-size: 16px;
  padding: 15px;
  box-sizing: border-box;
  padding-bottom: 30px;
  span,
  a,
  i,
  b,
  em {
    display: inline;
  }
  strong {
    font-weight: bold;
  }
  i {
    font-style: italic;
  }
}
</style>
